module.exports = __webpack_public_path__ + "img/solicitante2.4f6a0bc9.webp";